import { render, staticRenderFns } from "./PieStatisticsModular.vue?vue&type=template&id=160d63ed&scoped=true&"
import script from "./PieStatisticsModular.vue?vue&type=script&lang=js&"
export * from "./PieStatisticsModular.vue?vue&type=script&lang=js&"
import style0 from "./PieStatisticsModular.vue?vue&type=style&index=0&id=160d63ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160d63ed",
  null
  
)

export default component.exports